import { useState, FC } from 'react';
import styled from 'styled-components';

import TitleBlock, { TitleDescription } from '../../TitleBlock';
import CardModal from '../../modals/CardModal';
import Button from '../Button';
import { media } from '@anm/styles/helpers';

export type DeleteAccountButtonProps = {
  onDelete: () => void;
};
export type DeleteAccountProps = {
  onDelete: () => void;
  onModalClose: () => void;
};

const deleteAccountCardModalMobile = media.tablet`
  height: auto;
`;

const DeleteAccountCardModal = styled(CardModal)`
  text-align: center;
  width: 100%;
  max-width: 480px;
  padding-bottom: 10px;
  padding-top: 14px;
  background-color: #fff;
  border-radius: 5px;
  align-self: center;
  button {
    margin: 23px 10px 10px;
  }
  ${TitleDescription} {
    margin-top: 8px;
  }
  ${deleteAccountCardModalMobile};
`;

const DeleteModal: FC<DeleteAccountProps> = ({ onDelete, onModalClose }) => (
  <DeleteAccountCardModal
    onModalClose={onModalClose}
    isCloseButtonInsideModal={true}
    cardShadow={false}
  >
    <TitleBlock
      title="Delete Account"
      description="We are really sad to see you go!<br /> All your projects will be deleted. Are you sure?"
      size="medium"
    />

    <Button size="large_short" variant="bordered-red" onClick={onDelete}>
      Delete my account
    </Button>
    <Button size="large_short" variant="light-blue" onClick={onModalClose}>
      No, keep my account
    </Button>
  </DeleteAccountCardModal>
);

const DeleteAccountButton: FC<DeleteAccountButtonProps> = ({ onDelete }) => {
  const [isModalOpen, setModalOpen] = useState(false);
  const handleDelete = () => {
    onDelete();
    setModalOpen(false);
  };

  return (
    <div>
      {isModalOpen && (
        <DeleteModal
          onDelete={handleDelete}
          onModalClose={() => setModalOpen(false)}
        />
      )}
      <Button
        size="large"
        variant="bordered-red"
        onClick={() => setModalOpen(true)}
      >
        Delete Account
      </Button>
    </div>
  );
};

export default DeleteAccountButton;
